import { useEffect,useState } from 'react'
import api     from '../../services/apiClient'
import Button  from '../Shared/Button'
import Spinner from '../Shared/Spinner'
import Modal   from '../Shared/Modal'
import Input   from '../Shared/Input'

export default function LiveEvents() {
  const [events,setEvents]       = useState([])
  const [loading,setLoading]     = useState(true)
  const [selected,setSelected]   = useState(null)
  const [email,setEmail]         = useState('')
  const [submitting,setSubmitting]=useState(false)

  useEffect(()=>{
    api.get('/api/community/events?upcoming=true')
       .then(({data})=>setEvents(data))
       .finally(()=>setLoading(false))
  },[])

  const register=async()=>{
    if(!email.trim()) return
    setSubmitting(true)
    await api.post(`/api/community/events/${selected.id}/register`,{email})
    setSubmitting(false); setSelected(null); setEmail('')
    alert('Registered! Check your inbox.')
  }

  if(loading) return <div className="flex justify-center py-12"><Spinner/></div>

  return (
    <div className="p-unit space-y-unit">
      <h2 className="font-semibold text-charcoal">Upcoming live sessions</h2>

      {events.length===0 && <p className="text-sm italic">No upcoming events.</p>}

      <ul className="space-y-unit">
        {events.map(e=>(
          <li key={e.id} className="border rounded-2xl p-unit hover:bg-soft-yellow/30">
            <h3 className="font-semibold">{e.title}</h3>
            <p className="text-sm">{new Date(e.start_at).toLocaleString()} &middot; {e.duration} min</p>
            <p className="text-sm line-clamp-3">{e.description}</p>
            <Button intent="primary" size="sm" className="mt-2" onClick={()=>setSelected(e)}>
              Register
            </Button>
          </li>
        ))}
      </ul>

      {/* registration modal */}
      <Modal open={!!selected} title={selected?.title} onClose={()=>setSelected(null)}>
        <div className="space-y-4">
          <p className="text-sm">{new Date(selected?.start_at).toLocaleString()} — {selected?.duration} min</p>
          <Input label="E‑mail address" value={email} onChange={e=>setEmail(e.target.value)} autoFocus/>
          <div className="flex justify-end gap-2">
            <Button intent="secondary" onClick={()=>setSelected(null)}>Cancel</Button>
            <Button intent="primary" onClick={register} disabled={submitting}>
              {submitting && <Spinner size="xs" className="mr-1"/>}Register
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
